import { render, staticRenderFns } from "./ImsProfitLossTradeMapping.vue?vue&type=template&id=32137275&scoped=true&"
import script from "./ImsProfitLossTradeMapping.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossTradeMapping.vue?vue&type=script&lang=js&"
import style0 from "./ImsProfitLossTradeMapping.vue?vue&type=style&index=0&id=32137275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32137275",
  null
  
)

export default component.exports